import { Component, OnInit } from '@angular/core';
import { NatDateiTyp } from 'src/app/immutable/enums/nat-datei-typ';
import { ApiService } from 'src/app/services/api.service';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { ConstantsSonstige } from 'src/app/immutable/constants-sonstige';
import { FileType, GlobalFunctions , AppFileDataExt  } from 'globales-projekt-angular';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent implements OnInit {
  constructor(private apiService: ApiService) {}

  faInfo = faInfo;
  faHome = faHome;
  faDownload = faDownload;
  faQuestion = faQuestion;
  faCaretDown = faCaretDown;

  abkuerzungsverzeichnis: AppFileDataExt = new AppFileDataExt();

  ngOnInit(): void {

    /* ToDo später wieder einkommentieren und nutzen, auskommentiert wegen fehlermeldung die ich nicht ohne weiteres beheben kann
    this.apiService.getWorkAround().subscribe((response) => {
      let appFileList: AppFile[] = response;
      
      for (let entry of appFileList) {
        let appFileDataExt: AppFileDataExt = new AppFileDataExt(entry);

        if (appFileDataExt.idTyp == NatDateiTyp.ABKUERZUNGEN) {
          this.abkuerzungsverzeichnis = appFileDataExt;
        }
      }
    });*/
  }

  downloadPdfAbkuerzung() {
    this.downloadPdf(
      NatDateiTyp.ABKUERZUNGEN,
      ConstantsSonstige.FILENAME_ABKUERZUNG
    );
  }

  downloadPdf(natDateiTyp: NatDateiTyp, pdfName: string) {
    this.apiService.getPdf(natDateiTyp).subscribe((response) => {
      GlobalFunctions.downloadFile(FileType.PDF, response, pdfName, FileType.PDF_SHORT);
    });
  }
}
